export const ZIP_CODE_BASE_DIGITS = 5;
export const ZIP_CODE_MAX_DIGITS = 9;
export const ZIP_CODE_MAX_LENGTH = 10;
